import type { Dispatch, SetStateAction } from 'react';
import type { NavigationScreen } from 'app/types/navigation';
import type { useProfileActions, usePlaceProfileState } from './use-profile-screen-state';
import { ProfileBottomSheets } from './profile-bottom-sheets';

export function ProfileScreenSheets({
  profileActions,
  place,
  isMyself,
  isPlace,
  navigation,
  userId,
  showProfileActions,
  setShowProfileActions,
  shareProfile,
}: {
  profileActions: ReturnType<typeof useProfileActions>;
  place: ReturnType<typeof usePlaceProfileState>;
  isMyself: boolean;
  isPlace: boolean;
  navigation: React.ComponentProps<NavigationScreen<'neighbour-profile'>>['navigation'];
  userId: string;
  showProfileActions: boolean;
  setShowProfileActions: Dispatch<SetStateAction<boolean>>;
  shareProfile: () => unknown;
}) {
  const {
    handleReportUser,
    isAmbassadorSheetOpen,
    isReportingUser,
    setIsAmbassadorSheetOpen,
    setShowReportConfirmation,
    showReportConfirmation,
  } = profileActions;
  const {
    isJoining,
    isLeaving,
    joinPlace,
    leavePlace,
    placeDetails,
    placeMembers,
    setShowDiscount,
    setShowJoinConfirm,
    setShowLeaveConfirm,
    setShowOpeningHours,
    setShowPlaceHelp,
    setShowPlaceMembers,
    showDiscount,
    showJoinConfirm,
    showLeaveConfirm,
    showOpeningHours,
    showPlaceHelp,
    showPlaceMembers,
  } = place;
  return (
    <ProfileBottomSheets
      actions={{
        open: showProfileActions,
        onClose: () => setShowProfileActions(false),
        onShare: () => {
          setShowProfileActions(false);
          void shareProfile();
        },
        onReport:
          !isMyself && !isPlace && !isReportingUser
            ? () => {
                setShowProfileActions(false);
                setShowReportConfirmation(true);
              }
            : undefined,
      }}
      ambassador={{ onClose: () => setIsAmbassadorSheetOpen(false), open: isAmbassadorSheetOpen }}
      place={
        placeDetails
          ? {
              details: placeDetails,
              discount: { onClose: () => setShowDiscount(false), open: showDiscount },
              help: { onClose: () => setShowPlaceHelp(false), open: showPlaceHelp },
              join: {
                isJoining,
                onClose: () => setShowJoinConfirm(false),
                onJoin: () => joinPlace(userId),
                open: showJoinConfirm,
              },
              leave: {
                isLeaving,
                onClose: () => setShowLeaveConfirm(false),
                onLeave: () => leavePlace(userId),
                open: showLeaveConfirm,
              },
              members: placeMembers,
              membersSheet: { onClose: () => setShowPlaceMembers(false), open: showPlaceMembers },
              navigation,
              openingHours: { onClose: () => setShowOpeningHours(false), open: showOpeningHours },
            }
          : undefined
      }
      report={{
        onClose: () => setShowReportConfirmation(false),
        onConfirm: handleReportUser,
        open: showReportConfirmation,
      }}
    />
  );
}
